module.exports = __webpack_public_path__ + "img/is_bo_img.9ec17d00.png";